import api from './api';

const tenantService = {
  // Get all tenants
  getAllTenants: (params = {}) => {
    return api.get('/api/tenants', { params });
  },

  // Get single tenant
  getTenant: (id) => {
    return api.get(`/api/tenants/${id}`);
  },

  // Create new tenant
  createTenant: (data) => {
    return api.post('/api/tenants', data);
  },

  // Update tenant
  updateTenant: (id, data) => {
    return api.put(`/api/tenants/${id}`, data);
  },

  // Delete tenant
  deleteTenant: (id) => {
    return api.delete(`/api/tenants/${id}`);
  },

  // Reset tenant password
  resetPassword: (id, newPassword) => {
    return api.post(`/api/tenants/${id}/reset-password`, {
      new_password: newPassword
    });
  },

  // Get current tenant's dashboard data
  getTenantDashboard: () => {
    return api.get('/api/tenants/dashboard/me');
  },
};

export default tenantService;
